import { FullPageNotificationTemplate, FullPageNotificationTemplateProps } from './FullPageNotificationTemplate';

export { FullPageNotificationTemplate, FullPageNotificationTemplateProps };
